import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { combineLatest, first, map } from 'rxjs';

import { Store } from '@ngrx/store';
import { isNil } from 'ramda';

import { IAppState } from '../../index';

@Injectable({ providedIn: 'root' })
export class AppSettingsAndAuthGuard implements CanActivate {
    private readonly hasApplicationSettings$ = this.store
        .select((s) => s.applicationSettings) //
        .pipe(
            map((appSettings) => !isNil(appSettings.host) && !isNil(appSettings.port)), //
        );
    private readonly isLoggedIn$ = this.store.select((s) => s.currentUser.authToken && !isNil(s.currentUser.authToken)); //.pipe(tap((e) => console.log(e)));

    public constructor(
        private readonly store: Store<IAppState>, //
        private readonly router: Router,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
        const resolvedUrl = this.getResolvedUrl(route);

        return combineLatest([this.hasApplicationSettings$, this.isLoggedIn$]) //
            .pipe(
                first(),
                map(([hasApplicationSettings, isLoggedIn]) => {
                    if (hasApplicationSettings && !isLoggedIn && resolvedUrl !== '/login') {
                        return this.router.parseUrl('/login');
                    }

                    if (hasApplicationSettings && isLoggedIn && ['/login'].includes(resolvedUrl)) {
                        return this.router.parseUrl('/');
                    }

                    return true;
                }),
            );
    }

    private getResolvedUrl(route: ActivatedRouteSnapshot): string {
        const path = route.pathFromRoot
            .map((v) => v.url.map((s) => s.toString()).join('/'))
            .filter((e) => e?.length > 0)
            .join('/');

        return path.startsWith('/') ? path : `/${path}`;
    }
}
